module.exports = __webpack_public_path__ + "img/dxkj.2b00348c.png";